// src/hooks/cities/useGetCity.js
import { useQuery } from "@tanstack/react-query";
import { getCity } from "../../api/apiCities";

const useGetCity = (id) => {
    const { data, isLoading, error, refetch } = useQuery({
        queryKey: ["city", id],
        queryFn: () => getCity(id),
        enabled: !!id,
    });

    const city = data?.data || null;

    return { city, isLoading, error, refetch };
};

export default useGetCity;